"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAN_URL = void 0;
exports.BAN_URL = new URL('https://data.geopf.fr/geocodage/search');
